import { useContext } from "react";
import { useMainParticipant } from "../../hooks/useMainParticipant";
import { RoomContext } from "../../RoomContext";
import Participant from "./Participant";

const MainParticipant = () => {
  const mainParticipant = useMainParticipant();
  const { room } = useContext(RoomContext);
  const localParticipant = room.localParticipant;
  const isLocal = mainParticipant.identity === localParticipant.identity;

  return <Participant participant={mainParticipant} isLocal={isLocal} />;
};

export default MainParticipant;
